module.exports = __webpack_public_path__ + "static/media/cell.5a6eff28.svg";